import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/Api";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(""); // ✅ Mensaje de éxito o error general
  const [messageType, setMessageType] = useState(""); // ✅ "success" o "error"

  const validateForm = () => {
    const newErrors = {};
    if (email.trim() === "") newErrors.email = "El campo email es obligatorio.";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "El email no es válido.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      const response = await api.post("/reset-password", { email });

      // ✅ Mostrar mensaje de éxito en el front
      setMessage("Correo de recuperación enviado. Revisa tu bandeja de entrada.");
      setMessageType("success");
      setEmail(""); // limpia el campo
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
      setMessage("Hubo un problema al enviar el correo. Inténtalo de nuevo.");
      setMessageType("error");
    }
  };

  return (
    <div className="container-md w-50 mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 bg-white p-4 rounded shadow text-center">
          <h1 className="mb-3 fs-2">¿Has olvidado tu contraseña?</h1>
          <p>Introduce tu correo electrónico y recupera tu cuenta.</p>

          <form onSubmit={handleSubmit} className="mt-4">
            <div className="mb-3 text-start">
              <label className="d-block form-label" htmlFor="correo">
                Correo Electrónico:
              </label>
              <input
                className="form-control w-100"
                type="email"
                id="correo"
                name="correo"
                placeholder="Correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {errors.email && <div className="text-danger mt-1">{errors.email}</div>}
            </div>

            <button
              className="btn w-100"
              style={{ background: "#FF7A00", color: "#fff", border: "none" }}
              type="submit"
            >
              Recuperar Contraseña
            </button>
          </form>

          {/* ✅ Mensajes dinámicos */}
          {message && (
            <div
              className={`mt-3 ${
                messageType === "success" ? "text-success" : "text-danger"
              }`}
            >
              {message}
            </div>
          )}

          <div className="mt-3">
            <Link to="/" style={{ color: "#FF7A00", textDecoration: "none" }}>
              Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
